import { ArrowRightIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
export default function CardCategory({
  id,
  name,
  image,
  descriptionMini,
}: {
  id: string,
  name: string;
  image: string;
  descriptionMini: string;
}) {
  const getCategoryImage = (imgName: string) => {
    if (!imgName) return null;
    try {
      return require(`../assets/categories/${imgName}`);
    } catch (e) {
      console.warn(`Could not load category card image: ${imgName}`, e);
      return null;
    }
  };

  const imgSrc = getCategoryImage(image);

  return (
    <div className="bg-[#FAFAFA] rounded-2xl p-6 mb-6 flex flex-col justify-between">
      <div className="flex flex-nowrap justify-between">
        <div className="w-[40%] text-lg xl:text-3xl font-bold text-[#003459]">{name}</div>
        <div className="w-[50%] flex items-center justify-center">
          {imgSrc ? (
            <img src={imgSrc} alt={name} />
          ) : (
            <div className="w-16 h-16 rounded-xl bg-slate-200 border border-slate-300 flex items-center justify-center text-slate-400 font-bold select-none text-xs">
              MDI
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-[3fr_2fr] mt-6">
        <div className="text-[#003459]">{descriptionMini}</div>
        <Link to={`/ourProducts/${id}`} className="flex items-center font-semibold justify-end gap-3 text-lg text-[#0065AD] group hover:underline hover:cursor-pointer">
          Explore {name}
          <div>
            <ArrowRightIcon className="group-hover:underline"></ArrowRightIcon>
          </div>
        </Link>
      </div>
    </div>
  );
}
